import { render, staticRenderFns } from "./RemitosNewOrEdit.vue?vue&type=template&id=751d19ae&"
import script from "./RemitosNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./RemitosNewOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports